import { render, staticRenderFns } from "./OrderDetailsController.vue?vue&type=template&id=197ed90f&scoped=true"
import script from "./OrderDetailsController.vue?vue&type=script&lang=js"
export * from "./OrderDetailsController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ed90f",
  null
  
)

export default component.exports